import { PrivatePageHeader } from 'views/components/headers';

export const SessaoSincronizarHeader = () => {
  return <PrivatePageHeader title={'Sincronizando Sessão'} />;
};
